/**
 * Single source of truth for the build version label shown in the
 * Admin footer + Settings page. Bumped on every shipped iteration so
 * "is production stale?" becomes a 5-second visual check.
 *
 * Update both `iter` and `shipped_at` whenever you cut a new
 * iteration. The git commit hash is auto-injected at build time via
 * REACT_APP_GIT_SHA when set; falls back to "preview" otherwise.
 */
export const BUILD_VERSION = {
  app: "Oak AI Campus",
  version: "1.4",
  iter: 50,
  shipped_at: "2026-05-06",
  git_sha: (typeof process !== "undefined" && process.env.REACT_APP_GIT_SHA) || "preview",
};

export function buildLabel() {
  const { version, iter, shipped_at, git_sha } = BUILD_VERSION;
  return `v${version} · iter ${iter} · ${shipped_at} · ${git_sha.slice(0, 7)}`;
}
